import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

export class Conversation extends Model.Class<Conversation>("Conversation")({
  id: Model.Generated(Schema.String),
  personId: Schema.NullOr(Schema.String),
  title: Schema.NullOr(Schema.String),
  sceneKey: Schema.NullOr(Schema.String),
  feltTrueRating: Schema.NullOr(Schema.Number),
  feltTrueComment: Schema.NullOr(Schema.String),
  createdAt: Model.DateTimeInsertFromDate,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
